export default function Mobile() {
  return null;
}
